import { useEffect, useRef } from "react"

// relatedTarget null = the mouse left the page for the browser chrome or another window
export default function useExitIntent(onExitIntent: () => void, enabled = true) {
    const callbackRef = useRef(onExitIntent)

    useEffect(() => {
        callbackRef.current = onExitIntent
    }, [onExitIntent])

    useEffect(() => {
        if (!enabled) return
        const handleMouseOut = (e: MouseEvent) => {
            if (!e.relatedTarget) callbackRef.current()
        }
        document.addEventListener("mouseout", handleMouseOut)
        return () => document.removeEventListener("mouseout", handleMouseOut)
    }, [enabled])
}
